module.exports = __webpack_public_path__ + "static/media/AbbyssalBlade.dd261913.png";